import ApplicationController from './application_controller';
import { Controller } from "stimulus";
import * as tableModule from '../packs/tabulator/tabulator';
import { TabulatorFull as Tabulator } from "tabulator-tables";
import * as langs from "../packs/tabulator/langs";
import * as extensions from "../packs/tabulator/tabulator-extensions";

export default class extends Controller {
  static values = { id: String };

  connect() {
    super.connect();
    const that = this;

    extensions.extendTabulator();
    
    const tableWrapper = document.getElementById(`${this.idValue}_wrapper`);
    if (tableWrapper) {

      // Check if the table should get custom columns
      const tablesWithCustomColumns = [
        "profits",
        "room_orders_per_house",
        "debt",
        "room_orders_per_week",
        "room_orders_by_month",
        "occupancy",
        "classroom_bookings_by_month"
      ];

      if(tablesWithCustomColumns.includes(this.idValue))
      { 

        extensions.extendTabulator();
        that.table = new Tabulator(tableWrapper, {
          ajaxURL: "/reports/"+ this.idValue+"_data",
          height: "100%",
          pagination: "local",
          paginationSize: 25,
          selectableRows: 1,
          columns: this.columns(),
          textDirection: "rtl", // Force table into right-to-left text direction
          layout: "fitColumns",
          responsiveLayout: "hide", // Hide rows that no longer fit
          paginationSizeSelector: [10, 25, 50, 100], // Enable page size select element with these options
          persistenceID: `${this.idValue}_wrapper`,
          persistence: {
            sort: true, //persist column sorting
            filter: true, //persist filter sorting
            group: true, //persist row grouping
            page: true, //persist page
            columns: false, //persist columns
          },
          locale: "heb",
          langs: langs.getLang(),
        });

        window.tabulatorTables = window.tabulatorTables || {};
        window.tabulatorTables[this.idValue] = that.table;

      } else {
        that.table = tableModule.creatTabolatorTable(tableWrapper, this, '', {}, {
          pagination: "local",
          paginationSize: 50,
          selectableRows: 1,
          ajaxURL: 'remove',
          ajaxParams: 'remove',
          ajaxResponse: 'remove',
          columns: 'remove', // Apply only for the listed tables
          height: "100%",
          textDirection: "rtl", // Force table into right-to-left text direction
          layout: "fitColumns",
          groupClosedShowCalcs: true, // Show column calculations when a group is closed
          responsiveLayout: "hide", // Hide rows that no longer fit
          cellHozAlign: "right", // Right-align cell contents
          headerHozAlign: "center", // Center-align column header titles
          headerSortTristate: true, // Enable tristate header sort for all columns
          paginationSizeSelector: [10, 25, 50, 100], // Enable page size select element with these options
          persistence: true, // Enable persistence
          persistenceID: `${this.idValue}_wrapper`,
        });
        
        // Store table reference in a global object for date filter
        window.tabulatorTables = window.tabulatorTables || {};
        window.tabulatorTables[this.idValue] = that.table;

        // Listen for date range filter events
        document.addEventListener("date-range-filter:apply", (event) => {
          if (event.detail.tableId === this.idValue + "_wrapper") {
            this.filterTableByDateRange(event.detail.startDate, event.detail.endDate);
          }
        });
      }
    }
    
    $("#month-year-filter").on("change", (e) => {
      this.filterByMonthYear(e);
    });
  }
  
  columns() {
    switch (this.idValue) {
      case "profits":
        return [
          { field: "customer_name", title: "שם לקוח", headerFilter: true, sorter: "string", visible: true },
          { field: "customer_notes", title: "הערות לקוח", headerFilter: true, sorter: "string", visible: true },
          { field: "event_name", title: "אירוע", headerFilter: true, sorter: "string", visible: true },
          { field: "event_start_date", title: "תאריך התחלה", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "event_end_date", title: "תאריך סיום", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "status", title: "סטטוס", headerFilter: "list", headerFilterFunc: "in", headerFilterParams: { valuesLookup: "active", valuesLookupField: "status", multiselect: true, visible: true }, formatter: "statusFormatter", visible: true },
          { field: "final_price", title: "מחיר כולל", sorter: "number", headerFilter: true, bottomCalc: "sum", formatter: "money", formatterParams: { decimal: ".", thousand: ",", symbol: "₪", precision: false }, visible: true, accessorDownload: "numberAccessor" },
          { field: "maam", title: 'מע"מ', sorter: "number", headerFilter: true, visible: true, accessorDownload: "numberAccessor" },
          { field: "pre_maam_price", title: 'מחיר לא כולל מע"מ', sorter: "number", headerFilter: true, visible: true, accessorDownload: "numberAccessor" },
          { field: "pricing_name", title: "שם מחירון", headerFilter: true, sorter: "string", visible: true },
          { field: "total_meals_price", title: "עלות ארוחות", sorter: "number", headerFilter: true, visible: true, accessorDownload: "numberAccessor" },
          { field: "total_room_price", title: "עלות חדרים", sorter: "number", headerFilter: true, visible: true, accessorDownload: "numberAccessor" },
          { field: "total_classroom_price", title: "עלות כיתות", sorter: "number", headerFilter: true, visible: true, accessorDownload: "numberAccessor" },
        ];
  
      case "room_orders_per_house":
        return [
          { field: "event_name", title: "אירוע", headerFilter: true, sorter: "string", visible: true },
          { field: "space_name", title: "כיתה", headerFilter: true, sorter: "string", visible: true },
          { field: "house_name", title: "בית", headerFilter: true, sorter: "string", visible: true },
          { field: "pricing_name", title: "שם מחירון", headerFilter: true, sorter: "string", visible: true },
          { field: "unit_price", title: "מחיר ליחידה", sorter: "number", headerFilter: true, formatter: "money", visible: true, accessorDownload: "numberAccessor" },
          { field: "total_price", title: "מחיר כולל", sorter: "number", headerFilter: true, bottomCalc: "sum", formatter: "money", visible: true, accessorDownload: "numberAccessor" },
          { field: "event_start_date", title: "תאריך התחלה", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "event_end_date", title: "תאריך סיום", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
        ];
  
      case "debt":
        return [
          { field: "customer_name", title: "שם לקוח", headerFilter: true, sorter: "string", visible: true },
          { field: "phone_number", title: "טלפון", headerFilter: true, sorter: "string", visible: true },
          { field: "email", title: "אימייל", headerFilter: true, sorter: "string", visible: true },
          { field: "event_name", title: "אירוע", headerFilter: true, sorter: "string", visible: true },
          { field: "event_start_date", title: "תאריך התחלה", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "event_end_date", title: "תאריך סיום", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "event_month", title: "חודש אירוע", headerFilter: true, sorter: "number", visible: true, accessorDownload: "numberAccessor" },
          { field: "event_notes", title: "הערות אירוע", headerFilter: true, sorter: "string", visible: true },
          { field: "final_price", title: "חוב סופי", sorter: "number", headerFilter: true, bottomCalc: "sum", formatter: "money", visible: true, accessorDownload: "numberAccessor" },
        ];
  
      case "room_orders_per_week":
        return [
          { field: "event_name", title: "אירוע", headerFilter: true, sorter: "string", visible: true },
          { field: "event_start_date", title: "תאריך התחלה", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "event_start_time", title: "שעת התחלה", headerFilter: true, sorter: "string", visible: true },
          { field: "event_end_date", title: "תאריך סיום", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "event_end_time", title: "שעת סיום", headerFilter: true, sorter: "string", visible: true },
          { field: "participants_number", title: "מספר משתתפים", headerFilter: true, sorter: "number", visible: true, accessorDownload: "numberAccessor" },
          { field: "classroom_name", title: "שם כיתה", headerFilter: true, sorter: "string", visible: true },
          { field: "classroom_start_time", title: "שעת התחלת כיתה", headerFilter: true, sorter: "string", visible: true },
          { field: "classroom_end_time", title: "שעת סיום כיתה", headerFilter: true, sorter: "string", visible: true },
        ];
  
      case "room_orders_by_month":
        return [
          { field: "event_name", title: "אירוע", headerFilter: true, sorter: "string", visible: true },
          { field: "event_start_date", title: "תאריך התחלה", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "event_end_date", title: "תאריך סיום", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "space_name", title: "שם כיתה", headerFilter: true, sorter: "string", visible: true },
          { field: "night_amount", title: "מספר לילות", sorter: "number", headerFilter: true, visible: true, accessorDownload: "numberAccessor" },
          { field: "num_in_room", title: "כמות בחדר", sorter: "number", headerFilter: true, visible: true, accessorDownload: "numberAccessor" },
        ];

      case "occupancy":
        return [
          { field: "customer_name", title: "שם לקוח", headerFilter: true, sorter: "string", visible: true },
          { field: "event_name", title: "אירוע", headerFilter: true, sorter: "string", visible: true },
          { field: "pricing_name", title: "מחירון", headerFilter: true, sorter: "string", visible: true },
          { field: "rooms_count", title: "כמות חדרים תפוסים", headerFilter: true, sorter: "number", visible: true, accessorDownload: "numberAccessor" },
          { field: "participants_number", title: "כמות משתתפים באירוע", headerFilter: true, sorter: "number", visible: true, bottomCalc: "sum", accessorDownload: "numberAccessor" },
          { field: "beds_count", title: "כמות מיטות בחדר", headerFilter: true, sorter: "number", visible: true, bottomCalc: "sum", accessorDownload: "numberAccessor" },
          { field: "nights_count", title: "מספר לילות", headerFilter: true, sorter: "number", visible: true, bottomCalc: "sum", accessorDownload: "numberAccessor" },
          { field: "linens", title: "מצעים", headerFilter: true, sorter: "string", visible: true },
          { field: "towels_col", title: "מגבות", headerFilter: true, sorter: "string", visible: true },
          { field: "start_date", title: "תאריך התחלה", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "end_date", title: "תאריך סיום", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
        ];
      case "classroom_bookings_by_month":
        return [
          { field: "customer_name", title: "שם לקוח", headerFilter: true, sorter: "string", visible: true },
          { field: "event_name", title: "שם אירוע", headerFilter: true, sorter: "string", visible: true },
          { field: "status", title: "סטטוס", headerFilter: "list", headerFilterFunc: "in", headerFilterParams: { valuesLookup: "active", valuesLookupField: "status", multiselect: true, visible: true }, formatter: "statusFormatter", visible: true },
          { field: "event_start_date", title: "תאריך התחלה אירוע", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "event_end_date", title: "תאריך סיום אירוע", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "event_month", title: "חודש האירוע", headerFilter: true, sorter: "string", visible: true },
          { field: "days_count", title: "מספר ימים", headerFilter: true, sorter: "number", visible: true, bottomCalc: "sum", hozAlign: "left", accessorDownload: "numberAccessor" },
          { field: "space_name", title: "שם המשאב", headerFilter: true, sorter: "string", visible: true },
          { field: "chunk_start_date", title: "תאריך התחלה הזמנת כיתה", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "chunk_end_date", title: "תאריך סיום הזמנת כיתה", headerFilter: "minMaxFilterEditor", headerFilterFunc: "minMaxFilterFunction", visible: true, accessorDownload: "dateAccessor" },
          { field: "total_price", title: "מחיר הזמנת הכיתה", headerFilter: true, sorter: "number", visible: true, bottomCalc: "sum", hozAlign: "left", formatter: "money", formatterParams: { decimal: ".", thousand: ",", symbol: "₪", precision: 2 }, accessorDownload: "numberAccessor" },
          { field: "chunk_start_time", title: "שעת התחלה", headerFilter: true, sorter: "string", visible: true },
          { field: "chunk_end_time", title: "שעת סיום", headerFilter: true, sorter: "string", visible: true }
        ];
      default:
        return [
          { field: "id", title: "ID", visible: false }, // Default empty table, can be modified
        ];
    }
  }
  
  
  filterTableByDateRange(startDate, endDate) {
    if (startDate || endDate) {
      this.table.setFilter((data) => {
        const rowStartDate = new Date(data.event_start_date); // Adjust field as needed
        const rowEndDate = new Date(data.event_end_date); // Adjust field as needed
        
        if (startDate && rowStartDate < startDate) return false;
        if (endDate && rowEndDate > endDate) return false;
        return true;
      });
    } else {
      this.table.clearFilter();
    }
  }

  exportToXlsx(e) {
    const name = `${e.currentTarget.dataset.file_name}.xlsx` || "data";
    const table = window.tabulatorTables[this.idValue];
    tableModule.exportAsXlsx(table, name);
  }

  printTable(e) {
    const table = window.tabulatorTables[this.idValue];
    table.print("active", true);
  }

  saveLayout(e) {
    const wrapper = e.target.closest(".table-section.table-wrapper");
    const table = window.tabulatorTables[this.idValue];
    this.stimulate("settings#save_table_layout", wrapper.id + "_wrapper", JSON.stringify(table.getColumnLayout())).then(() => {
      table.setData();
    });
  }

  defaultLayout(e) {
    const wrapper = e.target.closest(".table-section.table-wrapper");
    const table = window.tabulatorTables[this.idValue];
    this.stimulate("settings#delete_table_layout", wrapper.id + "_wrapper").then(() => {
      table.setData();
    });
  }

  updateData(e) {
    const table = window.tabulatorTables[this.idValue];
    table.setData();
  }

  filterByMonthYear(e) {
    const selectedMonthYear = e.target.value;
    const reportId = e.target.dataset.reportId;

    // Construct the new URL
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("month_year", selectedMonthYear);

    // Redirect to the new URL
    window.location.href = currentUrl.toString();
  }
}